'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import omit from '../utils/underscore/omit';
import UIAbstractProgress from './UIAbstractProgress';
import UINanoProgress from './UINanoProgress';
export default class UIOptimisticNanoProgress extends Component {
  render() {
    const _this$props = this.props,
          {
      className,
      initialValue,
      optimismFactor,
      optimismIncrement,
      animateOnComplete,
      completionLinger,
      value: _value
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["className", "initialValue", "optimismFactor", "optimismIncrement", "animateOnComplete", "completionLinger", "value"]);

    return /*#__PURE__*/_jsx(UIAbstractProgress, {
      value: _value,
      initialValue: initialValue,
      incrementFactor: optimismFactor,
      incrementInterval: optimismIncrement,
      completionLingerTime: completionLinger,
      render: ({
        done,
        value
      }) => {
        if (value === null || done && animateOnComplete) {
          return null;
        }

        return /*#__PURE__*/_jsx(UINanoProgress, Object.assign({}, rest, {
          animateOnComplete: animateOnComplete,
          className: className,
          value: value
        }));
      }
    });
  }

}
UIOptimisticNanoProgress.displayName = 'UIOptimisticNanoProgress';
UIOptimisticNanoProgress.propTypes = Object.assign({}, UINanoProgress.propTypes, {
  // Time to start the progress bar at to be super optimistic
  initialValue: PropTypes.number,
  // Percentage to optimistically creep the bar on each increment
  optimismFactor: PropTypes.number,
  // Time interval to make optimisitc creeps
  optimismIncrement: PropTypes.number,
  // how long should component "linger" at 100% before
  // `done` is passed? This is helpful for CSS effects
  completionLinger: PropTypes.number
});
UIOptimisticNanoProgress.defaultProps = Object.assign({}, omit(UINanoProgress.defaultProps, ['value']), {
  initialValue: 0,
  completionLinger: 500,
  optimismFactor: 0.25,
  optimismIncrement: 150,
  animateOnComplete: false
});